import { YesNoIndicators } from '../../../../../global/models/api-model';

export enum PensionEnrollmentStep {
    Marital = 'Marital',
    Landing = 'Landing',
    Detail = 'Detail',
}

export const PensionEnrollmentSteps = [PensionEnrollmentStep.Landing, PensionEnrollmentStep.Detail];

export interface PensionEnrollmentState {
    pensionInfo: PensionEnrollmentInfo;
    pensionInfoLoaded: boolean;
    currentStep: PensionEnrollmentStep;
    successfulEnrolledPlan: string;
}

export enum PensionEnrollmentActionTypes {
    SET_PENSION_INFO = 'SET_PENSION_INFO',
    SET_PENSION_STEP = 'SET_PENSION_STEP',
    SET_SUCCESS_ENROLLED_PLAN = 'SET_SUCCESS_ENROLLED_PLAN',
    CLEAR_PENSION_INFO = 'CLEAR_PENSION_INFO',
}

export interface PensionEnrollmentPlanProduct {
    id: string;
    product: string;
    product_type: string;
    benefit: string;
    plan: string;
    optn: string;
    rider: string;
    description: string;
    pbpor_id: string;
    effective_date: string;
    end_date: string;
    dio_category: string;
    created_at: string;
    created_by: string;
    updated_at: string;
    updated_by: string;
}

export interface PensionEnrollmentPlan {
    id: number;
    employer_id: number;
    employer_client_number: string;
    pbpor_id: string;
    pbpor_description: string;
    plan_effective_date: string;
    enrollment_effective_date: string;
    effective_date: string;
    termination_date: string;
    deleted: any;
    plan_type: PensionEnrollmentPlanType;
    plan_id: number;
    enrollment_date: string;
    tac: string;
    employee_contribution: string;
    pretax_contribution?: string;

    amendment_date: string;
    billing_schedule: string;
    end_date: string;
    product: PensionEnrollmentPlanProduct;
    eligibility_result: {
        errors: string[];
    };
    division_code: string;
    dc_plan_id: string;
    bill_payer_employer_id: string;
    employee_client_number: string;
    bill_payer_employer_client_number: string;
    min_scheduled_hours: number;
    contribution_type: string;
    min_age: number;
    min_service: number;
    employer_override_allowed: YesNoIndicators;
    eligible_population: string;
    employer_base: number;
    employer_base_type: string;
    employer_match: number;
    employer_match_type: string;
}



export interface PensionEnrollmentInfo {
    plans: PensionEnrollmentPlan[];
    enrolled_plans: PensionEnrollmentPlan[];
}

export enum PensionEnrollmentPlanType {
    DbPlan = 'DbPlan',
    DcPlan = 'DcPlan',
    RsvpPlan = 'RsvpPlan',
}

export enum PensionEnrollmentContributionType {
    Percentage = 'percentage',
    FixedAmount = 'amount',
}

export enum PensionEnrollmentContributionTypePostValue {
    Percentage = 'percentage',
    FixedAmount = 'amount',
}

export enum BillPayerOption {
    Employer = 'employer',
    Diocese = 'diocese',
}

export const DB = 'DB';
export const DCRSVP = 'DC/RSVP';